<ihd-dialog-title>{{config.title | translate}}</ihd-dialog-title>
<ihd-dialog-body>
    {{config.content | translate}}
</ihd-dialog-body>
<ihd-dialog-actions>
    <ihd-button-group class="c-btn-group--column"
                      [class.justify-content-center]="config.dontSaveDisabled"
                      [class.justify-content-start]="!config.dontSaveDisabled">
        <button ihdButton class="c-btn--base c-btn--wlg c-btn--lg mr-auto"
                *ngIf="!config.dontSaveDisabled"
                [ihdDialogClose]="true"
                [disabled]="isClosing">
            {{'Common.DontSave'|translate}}
        </button>

        <button ihdButton type="button"
                class="c-btn--base c-btn--block c-btn--lg"
                ossDialogClose
                [disabled]="isClosing">
            {{'Common.Cancel'|translate}}
        </button>

        <button ihdButton type="button"
                class="c-btn--block c-btn--lg"
                ngClass="{{ config.okButtonClass }}"
                [class.c-btn--primary]="!config.okButtonClass"
                [disabled]="isClosing"
                (click)="process()">
            {{ okButtonTitle |translate}}
        </button>
    </ihd-button-group>
</ihd-dialog-actions>
